module.exports = __webpack_public_path__ + "media/stylesheets/images/Tatsuya Yumoto-34fedc240a04dd745eb545f7c363967f.jpg";